export default __webpack_public_path__ + "static/hero-mobile-36b6a253cb0e3df7dcd8121bc342ee8e.png";